// extracted by mini-css-extract-plugin
module.exports = {"LoadingSpinner__absolute__center":"LoadingSpinner_LoadingSpinner__absolute__center__2H9u6"};